import { FC, MutableRefObject } from 'react'
import { getStyledHeader } from '../../styled-components/ProductSection.styled'
import { getStyledSectionWrapper } from '../../styled-components/SectionWrapper.styled'
import { Arrow } from '../icons/Arrow.component'
import { SectionWrapper } from '../wrappers/SectionWrapper.component'

export interface FeaturesSectionProps {
    refItem: MutableRefObject<any>
}

export const FeaturesSection: FC<FeaturesSectionProps> = ({ refItem }) => {


    const StyledSectionWrapper = getStyledSectionWrapper(95)
    const HeaderWrapper = getStyledHeader()
    return (
        <StyledSectionWrapper ref={refItem}>
            <SectionWrapper>
                <>
                    <HeaderWrapper>
                        <span>Products</span>
                        <aside>
                            <p>See all</p>
                            <Arrow />
                        </aside>
                    </HeaderWrapper>
                    <div>Navbar</div>
                    <div>Products</div>
                </>
            </SectionWrapper>
        </StyledSectionWrapper>
    )
}